import { z } from 'zod';

export const uploadFiscalDocumentsSchema = z.object({
  fiscal_documents: z.array(
    z.object({
      id: z.string(),
      file: z.custom<File>().optional(),
      fileName: z.string(),
      currentFileUrl: z.string(),
    }),
  ).min(1, {message: 'Nota fiscal é obrigatória'})
});

export type UploadFiscalDocumentsValidationSchema = z.infer<typeof uploadFiscalDocumentsSchema>;
